import { useState, useMemo } from "react";
import {
  Search,
  MapPin,
  Briefcase,
  GraduationCap,
  School,
  ChevronDown,
  ChevronRight,
  BookOpen,
  CheckCircle,
  XCircle,
  Filter,
  X,
  Building2,
  Layers,
} from "lucide-react";
import { FormControl, MenuItem, Select } from "@mui/material";

const ALL_POSITIONS = [
  {
    positionName: "Mathematics and Science & Elementary Technology Teacher",
    qualificationLevel: "A2",
    role: "Teacher",
    schoolName: "GS CYAHAFI",
    schoolStatus: "Public",
    teachingCategoryName: "PRIMARY",
    sectorName: "Gitega",
    districtName: "Nyarugenge",
  },
  {
    positionName: "Secretary",
    qualificationLevel: "A2",
    role: "Secretary",
    schoolName: "GS CYAHAFI",
    schoolStatus: "Public",
    teachingCategoryName: "SECONDARY",
    sectorName: "Gitega",
    districtName: "Nyarugenge",
  },
  {
    positionName: "Languages Teacher",
    qualificationLevel: "A2",
    role: "Teacher",
    schoolName: "EP BIBUNGO",
    schoolStatus: "Public",
    teachingCategoryName: "PRIMARY",
    sectorName: "Kanyinya",
    districtName: "Nyarugenge",
  },
  {
    positionName: "Mathematics and Science & Elementary Technology Teacher",
    qualificationLevel: "A2",
    role: "Teacher",
    schoolName: "GS NZOVE",
    schoolStatus: "Public",
    teachingCategoryName: "PRIMARY",
    sectorName: "Kanyinya",
    districtName: "Nyarugenge",
  },
  {
    positionName: "Secretary",
    qualificationLevel: "A2",
    role: "Secretary",
    schoolName: "GS NZOVE",
    schoolStatus: "Public",
    teachingCategoryName: "SECONDARY",
    sectorName: "Kanyinya",
    districtName: "Nyarugenge",
  },
  {
    positionName: "Secretary",
    qualificationLevel: "A2",
    role: "Secretary",
    schoolName: "GS KANYINYA",
    schoolStatus: "Government aided",
    teachingCategoryName: "SECONDARY",
    sectorName: "Kanyinya",
    districtName: "Nyarugenge",
  },
  {
    positionName: "Secretary",
    qualificationLevel: "A2",
    role: "Secretary",
    schoolName: "GS KIGALI",
    schoolStatus: "Public",
    teachingCategoryName: "SECONDARY",
    sectorName: "Kigali",
    districtName: "Nyarugenge",
  },
  {
    positionName: "Social and Religious Education Teacher",
    qualificationLevel: "A2",
    role: "Teacher",
    schoolName: "GS KIGALI",
    schoolStatus: "Public",
    teachingCategoryName: "PRIMARY",
    sectorName: "Kigali",
    districtName: "Nyarugenge",
  },
  {
    positionName: "Secretary",
    qualificationLevel: "A2",
    role: "Secretary",
    schoolName: "GS MWENDO",
    schoolStatus: "Government aided",
    teachingCategoryName: "SECONDARY",
    sectorName: "Kigali",
    districtName: "Nyarugenge",
  },
  {
    positionName: "Secretary",
    qualificationLevel: "A2",
    role: "Secretary",
    schoolName: "GS KARAMA",
    schoolStatus: "Public",
    teachingCategoryName: "SECONDARY",
    sectorName: "Kigali",
    districtName: "Nyarugenge",
  },
  {
    positionName: "Logistician",
    qualificationLevel: "A0",
    role: "Laboratory",
    schoolName: "GS KARAMA",
    schoolStatus: "Public",
    teachingCategoryName: "TVET",
    sectorName: "Kigali",
    districtName: "Nyarugenge",
  },
  {
    positionName: "Tailoring Teacher",
    qualificationLevel: "A1",
    role: "Teacher",
    schoolName: "GS KARAMA",
    schoolStatus: "Public",
    teachingCategoryName: "TVET",
    sectorName: "Kigali",
    districtName: "Nyarugenge",
  },
  {
    positionName: "Logistician",
    qualificationLevel: "A0",
    role: "Laboratory",
    schoolName: "GS MAGERAGERE",
    schoolStatus: "Public",
    teachingCategoryName: "TVET",
    sectorName: "Mageragere",
    districtName: "Nyarugenge",
  },
  {
    positionName: "Networking and Internet Technology",
    qualificationLevel: "A0",
    role: "Teacher",
    schoolName: "GS MAGERAGERE",
    schoolStatus: "Public",
    teachingCategoryName: "TVET",
    sectorName: "Mageragere",
    districtName: "Nyarugenge",
  },
  {
    positionName: "Logistician",
    qualificationLevel: "A0",
    role: "Laboratory",
    schoolName: "GS GATSATA",
    schoolStatus: "Public",
    teachingCategoryName: "TVET",
    sectorName: "Gatsata",
    districtName: "Nyarugenge",
  },
  {
    positionName: "Patron",
    qualificationLevel: "A1",
    role: "Patron",
    schoolName: "GS GATSATA",
    schoolStatus: "Public",
    teachingCategoryName: "TVET",
    sectorName: "Gatsata",
    districtName: "Nyarugenge",
  },
  {
    positionName: "Public Works",
    qualificationLevel: "A0",
    role: "Laboratory",
    schoolName: "GS GATSATA",
    schoolStatus: "Public",
    teachingCategoryName: "TVET",
    sectorName: "Gatsata",
    districtName: "Nyarugenge",
  },
  {
    positionName: "Secretary",
    qualificationLevel: "A2",
    role: "Secretary",
    schoolName: "EP BIREMBO",
    schoolStatus: "Public",
    teachingCategoryName: "SECONDARY",
    sectorName: "Jabana",
    districtName: "Gasabo",
  },
  {
    positionName: "Logistician",
    qualificationLevel: "A0",
    role: "Laboratory",
    schoolName: "EP BIREMBO",
    schoolStatus: "Public",
    teachingCategoryName: "TVET",
    sectorName: "Jabana",
    districtName: "Gasabo",
  },
  {
    positionName: "ICT teacher",
    qualificationLevel: "A0",
    role: "Teacher",
    schoolName: "GS KIMIRONKO",
    schoolStatus: "Government aided",
    teachingCategoryName: "TVET",
    sectorName: "Kimironko",
    districtName: "Gasabo",
  },
];

const QUAL_META = {
  A0: { label: "Bachelor's Degree", color: "#0ea5e9", bg: "#e0f2fe" },
  A1: { label: "Advanced Diploma", color: "#8b5cf6", bg: "#ede9fe" },
  A2: { label: "High School", color: "#f59e0b", bg: "#fef3c7" },
};

const CAT_META = {
  PRIMARY: { color: "#10b981", bg: "#d1fae5" },
  SECONDARY: { color: "#3b82f6", bg: "#dbeafe" },
  TVET: { color: "#f97316", bg: "#ffedd5" },
};

const DISTRICT_COLORS = {
  Nyarugenge: { accent: "#1e40af", light: "#dbeafe", dot: "#3b82f6" },
  Gasabo: { accent: "#065f46", light: "#d1fae5", dot: "#10b981" },
};

const unique = (arr, key) => [...new Set(arr.map((d) => d[key]))].sort();

export default function PositionExplorer() {
  const [search, setSearch] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("All");
  const [selectedPosition, setSelectedPosition] = useState("All");
  const [selectedQual, setSelectedQual] = useState("All");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [expandedDistricts, setExpandedDistricts] = useState({
    Nyarugenge: true,
    Gasabo: true,
  });

  const [viewMode, setViewMode] = useState("district"); // "district" | "list"
  const [highlightedPosition, setHighlightedPosition] = useState(null);

  const districts = unique(ALL_POSITIONS, "districtName");
  const positions = unique(ALL_POSITIONS, "positionName");
  const quals = unique(ALL_POSITIONS, "qualificationLevel");
  const categories = unique(ALL_POSITIONS, "teachingCategoryName");

  const filtered = useMemo(() => {
    return ALL_POSITIONS.filter((p) => {
      const q = search.toLowerCase();
      const matchSearch =
        !q ||
        p.positionName.toLowerCase().includes(q) ||
        p.schoolName.toLowerCase().includes(q) ||
        p.sectorName.toLowerCase().includes(q) ||
        p.districtName.toLowerCase().includes(q);
      const matchDistrict =
        selectedDistrict === "All" || p.districtName === selectedDistrict;
      const matchPosition =
        selectedPosition === "All" || p.positionName === selectedPosition;
      const matchQual =
        selectedQual === "All" || p.qualificationLevel === selectedQual;
      const matchCat =
        selectedCategory === "All" ||
        p.teachingCategoryName === selectedCategory;
      return (
        matchSearch && matchDistrict && matchPosition && matchQual && matchCat
      );
    });
  }, [
    search,
    selectedDistrict,
    selectedPosition,
    selectedQual,
    selectedCategory,
  ]);

  const byDistrict = useMemo(() => {
    return districts.reduce((acc, d) => {
      acc[d] = filtered.filter((p) => p.districtName === d);
      return acc;
    }, {});
  }, [filtered, districts]);

  const activeFilters = [
    selectedDistrict !== "All" && {
      label: selectedDistrict,
      clear: () => setSelectedDistrict("All"),
    },
    selectedPosition !== "All" && {
      label:
        selectedPosition.length > 30
          ? selectedPosition.slice(0, 30) + "…"
          : selectedPosition,
      clear: () => setSelectedPosition("All"),
    },
    selectedQual !== "All" && {
      label: `Level: ${selectedQual}`,
      clear: () => setSelectedQual("All"),
    },
    selectedCategory !== "All" && {
      label: selectedCategory,
      clear: () => setSelectedCategory("All"),
    },
  ].filter(Boolean);

  const clearAll = () => {
    setSelectedDistrict("All");
    setSelectedPosition("All");
    setSelectedQual("All");
    setSelectedCategory("All");
    setSearch("");
  };

  const toggleDistrict = (d) =>
    setExpandedDistricts((prev) => ({ ...prev, [d]: !prev[d] }));

  const PositionCard = ({ p, i }) => {
    const qual = QUAL_META[p.qualificationLevel] || {};
    const cat = CAT_META[p.teachingCategoryName] || {};
    const dc = DISTRICT_COLORS[p.districtName] || { dot: "#94a3b8" };
    const isHighlighted = highlightedPosition === p.positionName;
    return (
      <div
        onMouseEnter={() => setHighlightedPosition(p.positionName)}
        onMouseLeave={() => setHighlightedPosition(null)}
        style={{
          padding: "14px 24px",
          display: "grid",
          gridTemplateColumns: "2fr 1fr 1fr 1fr",
          gap: 12,
          alignItems: "center",
          borderBottom: "1px solid #f8fafc",
          background: isHighlighted
            ? "#f0f9ff"
            : i % 2 === 0
              ? "#fafafa"
              : "#fff",
          transition: "background 0.1s",
        }}
      >
        <span style={{ fontSize: 13, fontWeight: 600, color: "#0f172a" }}>
          {p.positionName}
        </span>
        <span
          style={{
            background: qual.bg,
            color: qual.color,
            fontSize: 11,
            fontWeight: 700,
            padding: "3px 9px",
            borderRadius: 20,
            width: "fit-content",
          }}
        >
          {p.qualificationLevel}
        </span>
        <span
          style={{
            fontSize: 12,
            color: "#64748b",
            display: "flex",
            alignItems: "center",
            gap: 5,
          }}
        >
          <School size={12} />
          {p.schoolName}
        </span>

        <span
          style={{
            background: cat.bg,
            color: cat.color,
            fontSize: 11,
            fontWeight: 600,
            padding: "3px 9px",
            borderRadius: 8,
            width: "fit-content",
          }}
        >
          {p.teachingCategoryName}
        </span>
      </div>
    );
  };

  const samePositionCount = highlightedPosition
    ? filtered.filter((p) => p.positionName === highlightedPosition).length
    : 0;

  return (
    <div
      style={{
        fontFamily: "'Outfit', 'DM Sans', system-ui, sans-serif",
        background: "#f1f5f9",
        minHeight: "100vh",
      }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&family=DM+Sans:wght@400;500;600&display=swap');
        @keyframes fadeSlideIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes pulse { 0%,100% { opacity:1; } 50% { opacity:0.6; } }
        .pos-pill:hover { background: #1e40af !important; color: #fff !important; }
        select:focus { outline: 2px solid #3b82f6; }
      `}</style>

      {/* Hero Header */}
      <div
        style={{
          background:
            "linear-gradient(135deg, #0f172a 0%, #1e3a5f 60%, #0e4d3a 100%)",
          padding: "36px 32px 0",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: -60,
            right: -60,
            width: 300,
            height: 300,
            borderRadius: "50%",
            background: "rgba(59,130,246,0.06)",
            pointerEvents: "none",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: "40%",
            width: 200,
            height: 200,
            borderRadius: "50%",
            background: "rgba(16,185,129,0.05)",
            pointerEvents: "none",
          }}
        />

        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              marginBottom: 8,
            }}
          >
            <div
              style={{
                background: "#10b981",
                borderRadius: 8,
                padding: "4px 12px",
                fontSize: 11,
                fontWeight: 700,
                color: "#fff",
                letterSpacing: "0.07em",
                textTransform: "uppercase",
              }}
            >
              Rwanda Education Board
            </div>
          </div>
          <h1
            style={{
              margin: "0 0 8px",
              fontSize: 32,
              fontWeight: 800,
              color: "#fff",
              letterSpacing: "-0.03em",
            }}
          >
            Find Your Interested Position
          </h1>
          <p
            style={{
              margin: "0 0 28px",
              fontSize: 15,
              color: "rgba(255,255,255,0.6)",
              maxWidth: 520,
            }}
          >
            Explore available teaching vacancies across all districts and
            schools. <br /> Filter by location, position, or qualification to
            find where you fit.
          </p>

          {/* Search bar */}
          <div
            style={{ position: "relative", maxWidth: 600, marginBottom: 28 }}
          >
            <Search
              size={18}
              style={{
                position: "absolute",
                left: 16,
                top: "50%",
                transform: "translateY(-50%)",
                color: "#94a3b8",
                pointerEvents: "none",
              }}
            />
            <input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search by position, school, sector, or district…"
              style={{
                width: "100%",
                boxSizing: "border-box",
                padding: "14px 16px 14px 46px",
                borderRadius: 14,
                border: "1.5px solid rgba(255,255,255,0.15)",
                background: "rgba(255,255,255,0.08)",
                color: "#fff",
                fontSize: 15,
                backdropFilter: "blur(8px)",
                outline: "none",
              }}
            />
            {search && (
              <button
                onClick={() => setSearch("")}
                style={{
                  position: "absolute",
                  right: 14,
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  color: "#94a3b8",
                  display: "flex",
                }}
              >
                <X size={16} />
              </button>
            )}
          </div>

          {/* View mode toggle */}
          <div
            style={{
              display: "flex",
              gap: 0,
              background: "rgba(255,255,255,0.08)",
              borderRadius: 10,
              padding: 3,
              width: "fit-content",
              marginBottom: -1,
            }}
          >
            {[
              {
                id: "district",
                icon: <Layers size={15} />,
                label: "By District",
              },
              {
                id: "list",
                icon: <Briefcase size={15} />,
                label: "All Listings",
              },
            ].map((v) => (
              <button
                key={v.id}
                onClick={() => setViewMode(v.id)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  padding: "8px 18px",
                  borderRadius: 8,
                  border: "none",
                  cursor: "pointer",
                  fontSize: 13,
                  fontWeight: 600,
                  transition: "all 0.15s",
                  background: viewMode === v.id ? "#fff" : "transparent",
                  color:
                    viewMode === v.id ? "#0f172a" : "rgba(255,255,255,0.6)",
                }}
              >
                {v.icon}
                {v.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div
        style={{ maxWidth: 1100, margin: "0 auto", padding: "24px 32px 48px" }}
      >
        {/* Filters Row */}
        <div
          style={{
            background: "#fff",
            borderRadius: 14,
            border: "1px solid #e2e8f0",
            padding: "16px 20px",
            marginBottom: 20,
            display: "flex",
            flexWrap: "wrap",
            gap: 10,
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              color: "#64748b",
              fontSize: 13,
              fontWeight: 600,
              marginRight: 4,
            }}
          >
            <Filter size={15} />
            Filters
          </div>

          {[
            {
              label: "District",
              value: selectedDistrict,
              set: setSelectedDistrict,
              options: districts,
            },
            {
              label: "Position",
              value: selectedPosition,
              set: setSelectedPosition,
              options: positions,
            },
            {
              label: "Qualification",
              value: selectedQual,
              set: setSelectedQual,
              options: quals,
            },
            {
              label: "Level",
              value: selectedCategory,
              set: setSelectedCategory,
              options: categories,
            },
          ].map((f) => (
            <div key={f.label} style={{ position: "relative" }}>
              <select
                className="text-truncate"
                value={f.value}
                onChange={(e) => f.set(e.target.value)}
                style={{
                  appearance: "none",
                  background: f.value !== "All" ? "#eff6ff" : "#f8fafc",
                  border: `1.5px solid ${f.value !== "All" ? "#93c5fd" : "#e2e8f0"}`,
                  borderRadius: 9,
                  padding: "8px 32px 8px 12px",
                  fontSize: 13,
                  fontWeight: 500,
                  color: f.value !== "All" ? "#1d4ed8" : "#374151",
                  cursor: "pointer",
                  minWidth: 130,
                }}
              >
                <option value="All">All {f.label}s</option>
                {f.options.map((o) => (
                  <option key={o} value={o}>
                    {o}
                  </option>
                ))}
              </select>
              <ChevronDown
                size={13}
                style={{
                  position: "absolute",
                  right: 10,
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "#94a3b8",
                }}
              />
            </div>
          ))}

          {activeFilters.length > 0 && (
            <button
              onClick={clearAll}
              style={{
                marginLeft: "auto",
                display: "flex",
                alignItems: "center",
                gap: 5,
                background: "#fef2f2",
                border: "1px solid #fecaca",
                borderRadius: 8,
                padding: "7px 12px",
                fontSize: 12,
                fontWeight: 600,
                color: "#dc2626",
                cursor: "pointer",
              }}
            >
              <X size={12} />
              Clear all
            </button>
          )}
        </div>

        {/* Active filter chips */}
        {activeFilters.length > 0 && (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 8,
              marginBottom: 18,
            }}
          >
            {activeFilters.map((f, i) => (
              <span
                key={i}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  background: "#dbeafe",
                  color: "#1e40af",
                  fontSize: 12,
                  fontWeight: 600,
                  padding: "5px 12px",
                  borderRadius: 20,
                }}
              >
                {f.label}
                <button
                  onClick={f.clear}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    color: "#3b82f6",
                    display: "flex",
                    padding: 0,
                  }}
                >
                  <X size={12} />
                </button>
              </span>
            ))}
          </div>
        )}

        {/* Qualification Legend */}
        <div
          style={{
            marginBottom: 20,
            background: "#fff",
            borderRadius: 14,
            border: "1px solid #e2e8f0",
            padding: "20px 24px",
          }}
        >
          <h4
            style={{
              margin: "0 0 14px",
              fontSize: 13,
              fontWeight: 700,
              color: "#374151",
              display: "flex",
              alignItems: "center",
              gap: 6,
            }}
          >
            <GraduationCap size={15} color="#3b82f6" />
            Qualification Requirements Guide
          </h4>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
              gap: 12,
            }}
          >
            {Object.entries(QUAL_META).map(([k, v]) => (
              <div
                key={k}
                style={{
                  background: v.bg,
                  borderRadius: 10,
                  padding: "12px 16px",
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                }}
              >
                <span style={{ fontSize: 20, fontWeight: 800, color: v.color }}>
                  {k}
                </span>
                <div>
                  <div
                    style={{ fontSize: 13, fontWeight: 700, color: v.color }}
                  >
                    {v.label}
                  </div>
                  <div style={{ fontSize: 11, color: "#64748b", marginTop: 1 }}>
                    {filtered.filter((p) => p.qualificationLevel === k).length}{" "}
                    vacancies
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 20,
          }}
        >
          <p style={{ margin: 0, fontSize: 14, color: "#64748b" }}>
            Showing{" "}
            <span style={{ fontWeight: 700, color: "#0f172a" }}>
              {filtered.length}
            </span>{" "}
            vacant position{filtered.length !== 1 ? "s" : ""}
            {highlightedPosition && (
              <span
                style={{
                  marginLeft: 8,
                  background: "#fef3c7",
                  color: "#92400e",
                  padding: "2px 10px",
                  borderRadius: 20,
                  fontSize: 12,
                  fontWeight: 600,
                }}
              >
                ✦ {samePositionCount} "
                {highlightedPosition.length > 25
                  ? highlightedPosition.slice(0, 25) + "…"
                  : highlightedPosition}
                " across districts
              </span>
            )}
          </p>

          <div style={{ display: "flex", gap: 8 }}>
            {Object.entries({
              A0: "Bachelor's",
              A1: "Diploma",
              A2: "A-Level",
            }).map(([k, v]) => (
              <span
                key={k}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 5,
                  fontSize: 12,
                  color: "#64748b",
                }}
              >
                <span
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: 2,
                    background: QUAL_META[k].color,
                    display: "inline-block",
                  }}
                />
                {k} = {v}
              </span>
            ))}
          </div>
        </div>

        {filtered.length === 0 ? (
          <div
            style={{
              textAlign: "center",
              padding: "60px 20px",
              background: "#fff",
              borderRadius: 16,
              border: "1px solid #e2e8f0",
            }}
          >
            <XCircle size={40} color="#cbd5e1" style={{ marginBottom: 12 }} />
            <h3
              style={{ margin: "0 0 8px", color: "#0f172a", fontWeight: 700 }}
            >
              No positions found
            </h3>
            <p style={{ margin: "0 0 20px", color: "#64748b", fontSize: 14 }}>
              Try adjusting your filters or search terms.
            </p>
            <button
              onClick={clearAll}
              style={{
                background: "#3b82f6",
                color: "#fff",
                border: "none",
                borderRadius: 10,
                padding: "10px 24px",
                fontSize: 14,
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Clear all filters
            </button>
          </div>
        ) : viewMode === "district" ? (
          /* ── DISTRICT VIEW ── */
          <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
            {districts.map((district) => {
              const dPositions = byDistrict[district] || [];
              if (
                dPositions.length === 0 &&
                (selectedDistrict !== "All" || search || activeFilters.length)
              )
                return null;
              const isExpanded = expandedDistricts[district];
              const dc = DISTRICT_COLORS[district] || {
                accent: "#374151",
                light: "#f3f4f6",
                dot: "#6b7280",
              };
              const sectors = [...new Set(dPositions.map((p) => p.sectorName))];
              const uniquePositionNames = [
                ...new Set(dPositions.map((p) => p.positionName)),
              ];

              return (
                <div
                  key={district}
                  style={{
                    background: "#fff",
                    borderRadius: 18,
                    border: `2px solid ${dPositions.length > 0 ? dc.light : "#f0f0f0"}`,
                    overflow: "hidden",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                  }}
                >
                  {/* District Header */}
                  <button
                    onClick={() => toggleDistrict(district)}
                    style={{
                      width: "100%",
                      background:
                        dPositions.length > 0
                          ? `linear-gradient(to right, ${dc.light}, #fff)`
                          : "#f9fafb",
                      border: "none",
                      padding: "20px 24px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 16,
                    }}
                  >
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 14 }}
                    >
                      <div
                        style={{
                          width: 48,
                          height: 48,
                          borderRadius: 14,
                          background:
                            dPositions.length > 0 ? dc.accent : "#e5e7eb",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                        }}
                      >
                        <MapPin size={22} color="#fff" />
                      </div>
                      <div style={{ textAlign: "left" }}>
                        <h2
                          style={{
                            margin: 0,
                            fontSize: 20,
                            fontWeight: 800,
                            color: "#0f172a",
                          }}
                        >
                          {district} District
                        </h2>
                        <div
                          style={{
                            display: "flex",
                            gap: 12,
                            marginTop: 4,
                            flexWrap: "wrap",
                          }}
                        >
                          <span style={{ fontSize: 13, color: "#64748b" }}>
                            <b style={{ color: dc.accent }}>
                              {dPositions.length}
                            </b>{" "}
                            vacancy{dPositions.length !== 1 ? "ies" : ""}
                          </span>
                          {/* <span style={{ fontSize: 13, color: "#64748b" }}>
                            <b style={{ color: dc.accent }}>{sectors.length}</b>{" "}
                            sector{sectors.length !== 1 ? "s" : ""}
                          </span> */}
                          {/* <span style={{ fontSize: 13, color: "#64748b" }}>
                            <b style={{ color: dc.accent }}>
                              {uniquePositionNames.length}
                            </b>{" "}
                            unique role
                            {uniquePositionNames.length !== 1 ? "s" : ""}
                          </span> */}
                        </div>
                      </div>
                    </div>
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 12 }}
                    >
                      {/* Position pills preview */}
                      {/* <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 6,
                          maxWidth: 400,
                          justifyContent: "flex-end",
                        }}
                      >
                        {uniquePositionNames.slice(0, 4).map((pos) => (
                          <span
                            key={pos}
                            className="pos-pill"
                            style={{
                              background: "#f1f5f9",
                              color: "#475569",
                              fontSize: 11,
                              fontWeight: 600,
                              padding: "4px 10px",
                              borderRadius: 20,
                              border: "1px solid #e2e8f0",
                              transition: "all 0.15s",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {pos.length > 28 ? pos.slice(0, 28) + "…" : pos}
                          </span>
                        ))}
                        {uniquePositionNames.length > 4 && (
                          <span
                            style={{
                              background: dc.light,
                              color: dc.accent,
                              fontSize: 11,
                              fontWeight: 700,
                              padding: "4px 10px",
                              borderRadius: 20,
                            }}
                          >
                            +{uniquePositionNames.length - 4} more
                          </span>
                        )}
                      </div> */}
                      <div
                        style={{
                          background:
                            dPositions.length > 0 ? dc.light : "#f1f5f9",
                          borderRadius: 8,
                          padding: 6,
                          transition: "transform 0.2s",
                          transform: isExpanded
                            ? "rotate(90deg)"
                            : "rotate(0deg)",
                        }}
                      >
                        <ChevronRight
                          size={18}
                          color={dPositions.length > 0 ? dc.accent : "#9ca3af"}
                        />
                      </div>
                    </div>
                  </button>

                  {/* Expanded Content */}
                  {isExpanded && dPositions.length > 0 && (
                    <div style={{ padding: "0 24px 24px" }}>
                      {/* Sector grouping */}
                      {sectors.map((sector) => {
                        const sectorPositions = dPositions.filter(
                          (p) => p.sectorName === sector,
                        );
                        return (
                          <div key={sector} style={{ marginTop: 20 }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                                marginBottom: 12,
                              }}
                            >
                              <div
                                style={{
                                  width: 8,
                                  height: 8,
                                  borderRadius: "50%",
                                  background: dc.dot,
                                  flexShrink: 0,
                                }}
                              />
                              <h3
                                style={{
                                  margin: 0,
                                  fontSize: 13,
                                  fontWeight: 800,
                                  color: "#0122cc",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.06em",
                                }}
                              >
                                {sector} Sector
                              </h3>
                              <div
                                style={{
                                  flex: 1,
                                  height: 1,
                                  background: "#f1f5f9",
                                }}
                              />
                              <span style={{ fontSize: 12, color: "#94a3b8" }}>
                                {sectorPositions.length} position
                                {sectorPositions.length > 1 ? "s" : ""}
                              </span>
                            </div>
                            {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns:
                                  "repeat(auto-fill, minmax(300px, 1fr))",
                                gap: 10,
                              }}
                            > */}
                            {sectorPositions.map((p, i) => (
                              <PositionCard key={i} p={p} i={i} />
                            ))}
                            {/* </div> */}
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {isExpanded && dPositions.length === 0 && (
                    <div
                      style={{
                        padding: "24px",
                        textAlign: "center",
                        color: "#94a3b8",
                        fontSize: 14,
                      }}
                    >
                      No vacancies match your current filters in {district}.
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ) : (
          /* ── LIST VIEW ── */
          <div
            style={{
              background: "#fff",
              borderRadius: 18,
              border: "1px solid #e2e8f0",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                padding: "16px 24px",
                borderBottom: "1px solid #f1f5f9",
                display: "grid",
                gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr",
                gap: 12,
                fontSize: 11,
                fontWeight: 700,
                color: "#94a3b8",
                textTransform: "uppercase",
                letterSpacing: "0.06em",
              }}
            >
              <span>Position</span>
              <span>Qualification</span>
              <span>District · Sector</span>
              <span>School</span>
              <span>Level</span>
            </div>
            {filtered.map((p, i) => {
              const qual = QUAL_META[p.qualificationLevel] || {};
              const cat = CAT_META[p.teachingCategoryName] || {};
              const dc = DISTRICT_COLORS[p.districtName] || { dot: "#94a3b8" };
              const isHighlighted = highlightedPosition === p.positionName;
              return (
                <div
                  key={i}
                  onMouseEnter={() => setHighlightedPosition(p.positionName)}
                  onMouseLeave={() => setHighlightedPosition(null)}
                  style={{
                    padding: "14px 24px",
                    display: "grid",
                    gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr",
                    gap: 12,
                    alignItems: "center",
                    borderBottom: "1px solid #f8fafc",
                    background: isHighlighted
                      ? "#f0f9ff"
                      : i % 2 === 0
                        ? "#fff"
                        : "#fafafa",
                    transition: "background 0.1s",
                  }}
                >
                  <span
                    style={{ fontSize: 13, fontWeight: 600, color: "#0f172a" }}
                  >
                    {p.positionName}
                  </span>
                  <span
                    style={{
                      background: qual.bg,
                      color: qual.color,
                      fontSize: 11,
                      fontWeight: 700,
                      padding: "3px 9px",
                      borderRadius: 20,
                      width: "fit-content",
                    }}
                  >
                    {p.qualificationLevel}
                  </span>

                  <span
                    style={{
                      fontSize: 12,
                      color: "#64748b",
                      display: "flex",
                      alignItems: "center",
                      gap: 5,
                    }}
                  >
                    <span
                      style={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        background: dc.dot,
                        flexShrink: 0,
                      }}
                    />
                    {p.districtName} · {p.sectorName}
                  </span>

                  <span
                    style={{
                      fontSize: 12,
                      color: "#64748b",
                      display: "flex",
                      alignItems: "center",
                      gap: 5,
                    }}
                  >
                    <School size={12} />
                    {p.schoolName}
                  </span>

                  <span
                    style={{
                      background: cat.bg,
                      color: cat.color,
                      fontSize: 11,
                      fontWeight: 600,
                      padding: "3px 9px",
                      borderRadius: 8,
                      width: "fit-content",
                    }}
                  >
                    {p.teachingCategoryName}
                  </span>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
